import React from 'react'; 
import '../../../CSS/Main/portfolio.scss';
import {Smile} from 'react-feather';

const PortfolioContent = ({data})=> { 
  return (
    <div className="container pt-5">
        <div className="row pt-5">
            <div className="col-md-4 col-lg-4"></div>
            <div className="col-md-4 col-lg-4">
                <h5 className="header_or_link">{data.title} <span><Smile/></span></h5>
                <p className="default-paragraph">{data.content}</p>
            </div>
            <div className="col-md-4 col-lg-4"></div>
        </div>
    </div>
  );
}

export default PortfolioContent; 